/// <amd-module name="SuiteCommerce.FeaturedCategory.Common.Utils"/>
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
define("SuiteCommerce.FeaturedCategory.Common.Utils", ["require", "exports", "underscore", "SuiteCommerce.FeaturedCategory.Common.Configuration"], function (require, exports, _, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var profile = null;
    var RegistrationType;
    (function (RegistrationType) {
        // no login, no register, checkout as guest only
        RegistrationType["disabled"] = "disabled";
        // login, register, guest
        RegistrationType["optional"] = "optional";
        // login, register, no guest
        RegistrationType["required"] = "required";
        // login, no register, no guest
        RegistrationType["existing"] = "existing";
    })(RegistrationType || (RegistrationType = {}));
    function stringFormat(text) {
        var continuationText = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            continuationText[_i - 1] = arguments[_i];
        }
        return text.replace(/\$\((\d+)\)/g, function (match, number) {
            if (typeof continuationText[number] !== 'undefined') {
                return continuationText[number].toString();
            }
            return match.toString();
        });
    }
    function isUrlAbsolute(url) {
        return /^https?:\/\//.test(url);
    }
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.imageFlatten = function (images) {
            var _this = this;
            var result = [];
            if ('url' in images && 'altimagetext' in images) {
                return [images];
            }
            Object.getOwnPropertyNames(images).forEach(function (key) {
                if (_.isArray(images[key])) {
                    result.push(images[key]);
                }
                else {
                    result.push(_this.imageFlatten(images[key]));
                }
            });
            return _.flatten(result);
        };
        Utils.getThemeAbsoluteUrlOfNonManagedResources = function (defaultValue, file) {
            if (!file) {
                file = '';
                if (SC.ENVIRONMENT.isExtended) {
                    file = SC.ENVIRONMENT.themeAssetsPath || '';
                }
                else if (SC.ENVIRONMENT.BuildTimeInf && SC.ENVIRONMENT.BuildTimeInf.isSCLite) {
                    if (SC.CONFIGURATION.unmanagedResourcesFolderName) {
                        file = "site/" + SC.CONFIGURATION.unmanagedResourcesFolderName + "/";
                    }
                    else {
                        file = 'default/';
                    }
                }
                file += defaultValue;
            }
            return Utils.getAbsoluteUrl(file);
        };
        Utils.translate = function (text) {
            var continuationText = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                continuationText[_i - 1] = arguments[_i];
            }
            if (!text) {
                return '';
            }
            // Turns the arguments object into an array
            var parameters = [];
            // Checks the translation table
            var result = SC.Translations && SC.Translations[text] ? SC.Translations[text] : text;
            if (continuationText && continuationText.length && result) {
                var firstParameter = continuationText[0];
                if (_.isArray(firstParameter) && firstParameter.length) {
                    parameters = firstParameter;
                }
                else {
                    parameters = _.map(continuationText, function (param) {
                        return _.escape(param);
                    });
                }
            }
            result = stringFormat.apply(void 0, __spreadArrays([result], parameters));
            return result;
        };
        Utils.getAbsoluteUrl = function (file) {
            if (file === void 0) { file = ''; }
            var base_url = (SC && SC.ENVIRONMENT && SC.ENVIRONMENT.baseUrl) || '';
            var fileReplace = file;
            if (base_url && !isUrlAbsolute(fileReplace)) {
                return base_url.replace('{{file}}', fileReplace);
            }
            return file;
        };
        Utils.addParamsToUrl = function (baseUrl, params, avoidDoubleRedirect) {
            if (avoidDoubleRedirect) {
                var newParams_1 = {};
                _.each(params, function (paramValue, paramKey) {
                    newParams_1['__' + paramKey] = paramValue;
                });
                params = newParams_1;
            }
            // We get the search options from the config file
            if (baseUrl && !_.isEmpty(params)) {
                var paramString = jQuery.param(params);
                var joinString = baseUrl.indexOf('?') !== -1 ? '&' : '?';
                return baseUrl + joinString + paramString;
            }
            return baseUrl;
        };
        Utils.hidePrices = function () {
            if (this.userProfileData) {
                return (this.getRegistrationType() !== RegistrationType.disabled &&
                    Configuration_1.Configuration.get('siteSettings.requireloginforpricing', 'F') === 'T' &&
                    !this.userProfileData.isloggedin);
            }
            //SCA <19.1
            var ProfileModel = require('Profile.Model');
            return ProfileModel.getInstance().hidePrices();
        };
        Utils.getRegistrationType = function () {
            // registrationmandatory is 'T' when customer registration is disabled
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationmandatory', null) === 'T') {
                return RegistrationType.disabled;
            }
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationoptional', null) === 'T') {
                return RegistrationType.optional;
            }
            if (Configuration_1.Configuration.get('siteSettings.registration.registrationallowed', null) === 'T') {
                return RegistrationType.required;
            }
            return RegistrationType.existing;
        };
        Object.defineProperty(Utils, "userProfileData", {
            get: function () {
                if (profile) {
                    return profile;
                }
                return null;
            },
            set: function (profileData) {
                profile = profileData;
            },
            enumerable: true,
            configurable: true
        });
        return Utils;
    }());
    exports.Utils = Utils;
});
